import { Avatar, Dropdown, Typography } from '@doc/ui-components';
import Image from 'next/image';
import { useAuth, useTranslations } from '@power-core/toolkit';
import { getInitials } from '../utils/header.util';

export const UserMenu = () => {
	const t = useTranslations();
	const { auth, signOut } = useAuth();
	return (
		<Dropdown
			arrowIcon={false}
			header={
				<>
					<Typography className='pt-2 text-dark' size='text-base' weight='font-medium'>
						{auth?.data?.user?.name}
					</Typography>
					<Typography size='text-sm' weight='font-light' className='text-dark'>
						{auth?.data?.user?.email}
					</Typography>
				</>
			}
			label={
				<Avatar sizing='large'>
					{(auth?.data?.user?.image ?? '') ? (
						<Image alt='user avatar' height={40} src={auth?.data?.user?.image ?? ''} width={40} />
					) : (
						<Typography size='text-base' weight='font-semibold' className='text-dark'>
							{getInitials(auth?.data?.user?.name ?? '')}
						</Typography>
					)}
				</Avatar>
			}
			menuItems={[
				{
					label: (
						<Typography size='text-sm' weight='font-light' className='text-dark'>
							{t('T_SIGN_OUT')}
						</Typography>
					),
					onClick: signOut,
					value: 'Signout',
				},
			]}
		/>
	);
};
